import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { User, UserCheck } from 'lucide-react';

export default function AccountSwitcher() {
  const { user, login } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const accounts = [
    {
      email: 'alex.mercer@aether.fit',
      name: 'Alex Mercer',
      role: 'Client'
    },
    {
      email: 'sarah.johnson@aether.fit',
      name: 'Sarah Johnson',
      role: 'PT'
    }
  ];

  const handleSwitch = async (email: string) => {
    setLoading(true);
    try {
      await login(email);
      setIsOpen(false);
      // Reload to get fresh data
      window.location.reload();
    } catch (error) {
      console.error('Failed to switch account:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-lg text-gray-300 hover:bg-gray-700/50 hover:text-white transition-all"
      >
        <User className="w-4 h-4" />
        <span className="text-sm">{user?.name}</span>
        <span className={`text-xs px-2 py-1 rounded ${
          user?.role === 'pt' ? 'bg-purple-600' : 'bg-cyan-600'
        }`}>
          {user?.role === 'pt' ? 'PT' : 'Client'}
        </span>
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 right-0 w-72 bg-gray-800 border border-gray-700 rounded-lg shadow-xl z-50">
          <div className="p-4">
            <h3 className="text-sm font-semibold text-gray-400 mb-3">Switch Account</h3>
            <div className="space-y-2">
              {accounts.map((account) => (
                <button
                  key={account.email}
                  onClick={() => handleSwitch(account.email)}
                  disabled={loading || user?.email === account.email}
                  className={`w-full p-3 rounded-lg text-left transition-all ${
                    user?.email === account.email
                      ? 'bg-gray-700 border border-gray-600'
                      : 'bg-gray-700/50 hover:bg-gray-700 border border-transparent'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="font-medium text-white flex items-center gap-2">
                        {account.name}
                        {user?.email === account.email && (
                          <UserCheck className="w-4 h-4 text-green-400" />
                        )}
                      </div>
                      <div className="text-xs text-gray-400">{account.email}</div>
                    </div>
                    <span className={`text-xs px-2 py-1 rounded ${
                      account.role === 'PT' ? 'bg-purple-600' : 'bg-cyan-600'
                    }`}>
                      {account.role}
                    </span>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}